const propertyFileTypes = {
  NOTICE_OF_DEFICIENCIES: 'Notice of Deficiencies',
  ENFORCMENT_NOTICE: 'Enforcement Notice',
  LEGIONELLA_CERTIFICATE: 'Legionella Certificate',
  ASBESTOS_REPORT: 'Asbestos Report',
  LANDLORD_EICR: 'Landlord EICR',
  FLATS_EICR: 'Flats EICR',
  SMOKE_ALARAMS_IN_FLATS: 'Smoke Alarms in Flats',
  COMMON_AREA_SMOKE_ALARMS: 'Common Area Smoke Alarms',
  EXTERNAL_WALL_SURVEY: 'External Wall Survey',
  LEGACY_FIRE_RISK_ASSESSMENT: 'Legacy Fire Risk Assessment',
};

export default propertyFileTypes;
